import { AxiosError } from 'axios';
import { userClient } from '../config/api';

export interface EvaluatorSignatureData {
  id: string;
  evaluatorName: string;
  creaCauNumber?: string;
  signatureBase64: string;
  createdAt: string;
  updatedAt: string;
}

export interface SaveEvaluatorSignatureData {
  evaluatorName: string;
  creaCauNumber?: string;
  signatureBase64: string;
}

class EvaluatorSignatureService {
  async getSignature(): Promise<EvaluatorSignatureData | null> {
    try {
      const response = await userClient.get('/api/evaluator-signature');
      return response.data.data;
    } catch (error: unknown) {
      if (error instanceof AxiosError && error.response?.status === 404) {
        return null;
      }
      throw error;
    }
  }

  async getSignatureByUserId(userId: string): Promise<EvaluatorSignatureData | null> {
    try {
      const response = await userClient.get(`/api/evaluator-signature/${userId}`);
      return response.data.data;
    } catch (error: unknown) {
      if (error instanceof AxiosError && error.response?.status === 404) {
        return null;
      }
      throw error;
    }
  }

  async createSignature(data: SaveEvaluatorSignatureData): Promise<string> {
    const response = await userClient.post('/api/evaluator-signature', data);
    return response.data.data;
  }

  async updateSignature(data: SaveEvaluatorSignatureData): Promise<void> {
    await userClient.put('/api/evaluator-signature', data);
  }

  async saveSignature(data: SaveEvaluatorSignatureData): Promise<void> {
    const existing = await this.getSignature();

    if (existing) {
      await this.updateSignature(data);
    } else {
      await this.createSignature(data);
    }
  }
}

export const evaluatorSignatureService = new EvaluatorSignatureService();
